module.exports = __webpack_public_path__ + "static/media/bg_unconnected_ar.1674cf80.png";